import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import { length, propEq, findIndex } from 'ramda'
import HeadBar from '../HeadBar'
import Container from '../../components/Container'
import { TabsStyled, StyledTabsHeader, StyledTabsContent, TabsWrraperStyled, TabStyled, IndicatorStyled } from './styled.js'

//TODO add scroll
const Tabs = ({ defaultID = null, headBar, tabs, showTabsHeader, onAfterChangeTab }) => {
    const history = useHistory();
    const { state, state: { tabID = null } = {} } = useLocation();
    const [enabledTabs, setEnabledTabs] = useState([]);
    const [activeID, setActiveID] = useState(defaultID);

    useEffect(() => {
        if (tabs) {
            const parsedTabs = tabs.filter(({ showTab = true }) => showTab).map(({ id, name }) => ({ id, name }));
            setEnabledTabs(parsedTabs);
            if (tabID !== null && tabID !== activeID) {
                setActiveID(tabID)
            } else if (activeID === null && parsedTabs[0]) {
                setActiveID(parsedTabs[0]['id'])
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabs])

    // useEffect(() => {
    //     if (tabID !== activeID) {
    //         setActiveID(tabID)
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [tabID])

    useEffect(() => {
        onAfterChangeTab && onAfterChangeTab(activeID)
        history.replace({
            pathaname: history.location.pathname,
            state: {
                ...state,
                tabID: activeID
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeID])

    const handleClickTab = id => () => {
        setActiveID(id);
    }

    const findActiveTab = () => {
        const tabsFiltered = tabs.filter(({ showTab = true }) => showTab);
        const activeTab = tabsFiltered.find(tab => tab.id === activeID);
        if (activeTab !== undefined) {
            return {
                index: findIndex(propEq('id', activeTab.id), tabsFiltered),
                tab: activeTab
            };
        } else if (tabsFiltered[0] !== undefined) {
            return {
                index: 0,
                tab: tabsFiltered[0]
            };
        } else {
            return {
                index: null,
                tab: null
            }
        }
    }

    const active = findActiveTab();

    return (
        <>
            {
                headBar &&
                <HeadBar
                    title={headBar.title}
                    noShadow
                >
                    {
                        (active.tab && active.tab['headBarChildren']) ? active.tab['headBarChildren'] : headBar.children
                    }
                </HeadBar>
            }
            <TabsStyled>
                <StyledTabsHeader pose={showTabsHeader ? 'visible' : 'hidden'}>
                    <Container>
                        <TabsWrraperStyled>
                            {
                                enabledTabs &&
                                enabledTabs.map(({ id, name }) =>
                                    <TabStyled
                                        key={id}
                                        isActive={id === activeID}
                                        onClick={handleClickTab(id)}
                                    >
                                        {name}
                                    </TabStyled>
                                )
                            }
                        </TabsWrraperStyled>
                        <IndicatorStyled
                            quantity={length(enabledTabs)}
                            value={active.index}
                        />
                    </Container>
                </StyledTabsHeader>
                <StyledTabsContent>
                    <Container>
                        {
                            active.tab &&
                            active.tab['component']
                        }
                    </Container>
                </StyledTabsContent>
            </TabsStyled>
        </>
    )
}

Tabs.defaultProps = {
    showTabsHeader: true
}

export default Tabs
